import type { ImageSize, RhinoImageRatio } from '../..';
import { useCategoryTreeItem } from '../categoryTree/useCategoryTreeItem';
import { KuxFilteredCategoriesDTO } from '../compat/tvpil';

import { MoreLink } from './types';
import { useRailSettings } from './useRailSettings';

export type UseContinueWatchingSettingsProps = {
  defaultImageRatio?: RhinoImageRatio;
  defaultLandscapeImageHeight?: number;
  defaultPortraitImageHeight?: number;
  imageSize?: ImageSize;
  referenceId: string;
};

export type ContinueWatchingSettings = {
  branding: KuxFilteredCategoriesDTO['uiDesignElements'];
  id: number;
  imageHeight?: number;
  imageType?: number;
  imageWidth?: number;
  moreLink: MoreLink | undefined;
  parentalPinProtected: boolean;
  shouldGroupEpisodes: boolean;
  shouldShowEntitlementIndicator: boolean;
  shouldShowRating: boolean;
  title: string;
};

export function useContinueWatchingSettings(
  props: UseContinueWatchingSettingsProps,
): ContinueWatchingSettings | undefined {
  const category = useCategoryTreeItem(props.referenceId);
  const railSettings = useRailSettings(props);

  if (!category || !railSettings) {
    return undefined;
  }

  const {
    branding,
    id,
    imageHeight,
    imageType,
    imageWidth,
    moreLink,
    parentalPinProtected,
    shouldShowEntitlementIndicator,
    shouldShowRating,
    title,
  } = railSettings;
  const shouldGroupEpisodes = Boolean(category.continueWatchingProperty.useSuppress);

  return {
    branding,
    id,
    imageHeight,
    imageType,
    imageWidth,
    moreLink,
    parentalPinProtected,
    shouldGroupEpisodes,
    shouldShowEntitlementIndicator,
    shouldShowRating,
    title,
  };
}
